import { JSX } from 'react'


import { HttpBody } from '@/lib/request.js'

import * as company_storage from '@/storage/company.js'
import * as contract_storage from '@/storage/contract.js'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Field from '@/components/ui/field.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Fieldset from '@/components/ui/fieldset.tsx'




export default function
(
	props: {
		doc: HttpBody<contract_storage.TRawDocumentType>

		update(name: string, value: unknown): void

	},

)
:	JSX.Element
{
	let { company, sign, settle } = props.doc

	let on_update = (name: string, value: unknown): void =>
	{
		props.update(name, value)

	}

	let on_fit = async (_id: string): Promise<string> =>
	{
		let doc = await company_storage.retrieve(_id)

		return doc.name

	}

	let on_search = async (keyword: string): Promise< Field.LinkerItem[] > =>
	{
		let doc = await company_storage.retrieves(
			{ keyword, league: '^', skip: 0, limit: 99, sort: ['-created'] },

		)

		return doc.map(
			v => ({ value: v._id, label: v.name }),

		)

	}

	return (
		<Fieldset.Root name="签约信息">
			<Fieldset.Group>
				<Field.Linker
					label="所属项目"
					helper="请选择所属项目"
					name="company"
					value={company}
					fit={on_fit}
					search={on_search}
					change={on_update}
				/>

				<Field.Text label="合同主体" name="sign" value={sign} change={on_update} />

				<Field.Text label="结算公司" name="settle" value={settle} change={on_update} />

			</Fieldset.Group>

		</Fieldset.Root>

	)

}

